export default {
  job51: 2,
  zhiLian: 3,
  liepin: 4
}
